<div class="row pt-2 pb-2 bg-white">
  <div class="col-12">

    <!-- Loader & Empty message -->
    <div class="row" *ngIf="retailersLoading === true">
      <div class="col-12 text-center">
        <div class="spinner-border text-info mt-4" role="status"></div>
      </div>
    </div>

    <!-- Retailers -->
    <div class="row mt-2" *ngIf="retailersLoading === false && couponData?.retailers">
      <div class="col-12">
        <div class="card  mb-3" *ngFor="let retailer of couponData?.retailers; let i = index;">
          <!-- Retailer details (only for CPG)-->
          <div class="card-header bg-white" *ngIf="module == 'CPG'">
            <div class="row">
              <div class="col-6">
                <h6 class="text-muted mt-3">{{ retailer.retailer_name  }}</h6>
              </div>
              <div class="col-6">
                <img class="logo float-end" [src]="retailer.logo">
              </div>
            </div>
          </div>
          <!-- Store details-->
          <div class="card-body">
            <div class="row">
              <div class="col-1 col-md-1"></div>
              <div class="col-4 col-md-4">
                <span class="small-label text-muted">Stores</span>
              </div>
              <div class="col-3 col-md-3">
                <span class="small-label text-muted">Start & End Dates</span>
              </div>
              <div class="col-2 col-md-2">
                <span class="small-label text-muted">Qty Per Transaction</span>
              </div>
              <div class="col-2 col-md-2">
                <span class="small-label text-muted">Max Redemptions</span>
              </div>
            </div>
            <div class="row mb-1" *ngFor="let store of retailer.stores;">
              <div class="col-1 col-md-1">
                <div class="form-check form-switch selection" (change)="onStoreClick($event, retailer, store)">
                  <input type="checkbox" class="form-check-input" [id]="store.store_id" [checked]="store.status">
                  <label class="form-check-label" [for]="store.store_id"></label>
                </div>
              </div>
              <div class="col-4 col-md-4">
                <span class="store-name text-muted">{{ store.store_name }}</span>
              </div>
              <div class="col-3 col-md-3">
                <input type="text" class="form-control form-control-sm text-muted" [id]="'date_range_' + retailer.retailer_id + '_' + store.store_id" placeholder="Select coupon date range" bsDaterangepicker [bsConfig]="calendarConfig" [minDate]="calendarMinDate" [bsValue]="store.date_range" (bsValueChange)="onCalendarValueChange($event, retailer, store)">
              </div>
              <div class="col-2 col-md-2">
                <input type="number" class="form-control form-control-sm text-muted" [id]="'max_redeem_quantity_' + retailer.retailer_id + '_' + store.store_id" placeholder="" [(ngModel)]="store.max_redeem_quantity">
              </div>
              <div class="col-2 col-md-2">
                <input type="number" class="form-control form-control-sm text-muted" [id]="'max_redemptions_' + retailer.retailer_id + '_' + store.store_id" placeholder="" [(ngModel)]="store.max_redemptions">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Next/Previuos Buttons -->
    <div class="row mt-3 pt-3 mb-0 border-top">
      <div class="col-6"></div>
      <div class="col-6 text-end">
        <button type="button" class="btn btn-secondary text-white fw-bold"  title="Select Retailers" (click)="onNavigationClick('previous', coupon_save_confirm_modal)">
          <i-bs class="text-light" name="arrowLeft" width="22" height="22"></i-bs>
        </button>
        &nbsp;
        <button type="button" class="btn btn-secondary text-white fw-bold" title="Save Coupon" (click)="onNavigationClick('submit', coupon_save_confirm_modal)">
          <i-bs class="text-light" name="cloudArrowUp" width="22" height="22"></i-bs>
        </button>
      </div>
    </div>

  </div>
</div>

<!-- Coupon Save Confirm Modal -->
<ng-template #coupon_save_confirm_modal>
  <div class="modal-header">
    <h6 class="modal-title text-muted float-start">Create Coupon</h6>

    <i-bs class="text-muted cursor-pointer float-end" name="xCircle" title="Close" (click)="hideCouponSaveConfirmModal()"></i-bs>
  </div>

  <div class="modal-body">
    <p class="text-muted">Are you sure you want to create this coupon?</p>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-dark fw-bold" title="Cancel" [disabled]="creatingCoupon" (click)="hideCouponSaveConfirmModal()">
      No
    </button>

    <button type="button" class="btn btn-secondary text-white fw-bold" title="Create Coupon" [disabled]="creatingCoupon" (click)="createCoupon()">
      Yes
      <div class="spinner-border spinner-border-sm" role="status" *ngIf="creatingCoupon"></div>
    </button>
  </div>
</ng-template>
